import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { LandingCopyIcon } from "../../../../assets/icons";
import { CardFrame } from "../../../../common/components/card-frame/CardFrame";
import { SelectableItem } from "../../../../common/components/selectable-item/SelectableItem";
import CustomerPageLayout from "../../customer-page-layout/CustomerPageLayout";
import { handleCopy } from "../../../../utils";

export const CallCenter = () => {
	const { t } = useTranslation();
	const handleCopy = (text: string) => {
		navigator.clipboard.writeText(text);
		toast.success(t("support.web.phoneNumberCopied"));
	};
	return (
		<CustomerPageLayout title={t("support.supportCallCenterTitle")} showBackButton={true}>
			<CardFrame>
				<SelectableItem onClick={() => handleCopy("+2347080671170")} title="+234 708 067 1170" subtitle="" rightIcon={<LandingCopyIcon />} />
				<SelectableItem hideBottomBorder onClick={() => handleCopy("+2347001235666")} title="+234 700 123 5666" subtitle="" rightIcon={<LandingCopyIcon />} />
			</CardFrame>
		</CustomerPageLayout>
	);
};
